import { inject, Injectable, signal, WritableSignal } from '@angular/core';
import { of } from 'rxjs/internal/observable/of';
import { filter, map, take } from 'rxjs/operators';

import { CrudService, PostEntityModel } from 'collection';

@Injectable({
  providedIn: 'root'
})
export class MittanbudService {
  private _crud: CrudService = inject(CrudService);

  closedByUser: WritableSignal<boolean> = signal(false);
  closedByAccount: WritableSignal<boolean> = signal(false);

  mittanbudEntity: PostEntityModel;
  initMittanbud() {
    return this.mittanbudEntity.save();
  }

  parseResponse(res): any {
    const parsedData = JSON.parse(res['data'].value);
    const transformedData = Object.keys(parsedData).reduce((acc, key) => {
      acc[key] = parsedData[key].value;
      return acc;
    }, {});
    return transformedData;
  }

  getAccountPermission(isAdmin) {
    if (isAdmin) {
      return this._crud
        .createGetEntity({ name: 'account-toggle-settings' })
        .get()
        .pipe(
          take(1),
          filter(({ success }) => success),
          map((res) => this.parseResponse(res))
        );
    } else {
      return of(false);
    }
  }

  getUserPermission() {
    return this._crud
      .createGetEntity({ name: 'user-toggle-settings' })
      .get()
      .pipe(
        take(1),
        filter(({ success }) => success),
        map((res) => this.parseResponse(res))
      );
  }

  closeByUser(data) {
    return this._crud.createUpdateEntity({ name: 'user-toggle-settings' }).update({ data }).pipe(take(1));
  }

  closeByAccount(data) {
    return this._crud.createUpdateEntity({ name: 'account-toggle-settings' }).update({ data }).pipe(take(1));
  }

  constructor() {
    this.mittanbudEntity = this._crud.createPostEntity({ name: 'mittanbud' });
  }
}
